<template>
  <div class="pagination">
    <van-pagination
      v-model="cur"
      :force-ellipses="total > 24 ? true : false"
      :items-per-page="8"
      :next-text="'Next'"
      :prev-text="'Previous'"
      :show-page-size="pagesize"
      :total-items="total"
      @change="pageChange"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      // cur: 1,
      pagesize: 3
    };
  },
  props: {
    total: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    cur: {
      type: Number,
      default: () => {
        return 1;
      }
    }
  },
  created() {
    var that = this;
    if (that.total > 32) {
      that.pagesize = 2;
    }
  },
  methods: {
    pageChange(page) {
      var that = this;
      that.$emit("accept", page);
      let last = that.total / 8;
      let int_val = parseInt(last);
      if (last > int_val) {
        last = int_val + 1;
      }
      if (that.total > 32 && page > 2) {
        if (page !== last) that.pagesize = 2;
        else that.pagesize = 3;
      }
    }
  },
  watch: {
    total(val) {
      if (val > 32) {
        this.pagesize = 2;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  padding: 0 0.12rem;
  margin: 0.3rem auto 0.6rem auto;
}
</style>



// WEBPACK FOOTER //
// src/components/package/pagination.vue